import React from "react";
import { useNavigate } from "react-router-dom";

const AnkleFootBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .afb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #eef2ff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .afb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .afb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(129, 140, 248, 0.25), rgba(56, 189, 248, 0.12));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .afb-hero {
            grid-template-columns: 1fr;
          }
        }

        .afb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(129, 140, 248, 0.25);
          color: #3730a3;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .afb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #6366f1;
        }

        .afb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .afb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .afb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .afb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .afb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .afb-btnPrimary,
        .afb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .afb-btnPrimary {
          background: #6366f1;
          color: #eef2ff;
          box-shadow: 0 10px 24px rgba(79, 70, 229, 0.45);
        }

        .afb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(79, 70, 229, 0.65);
        }

        .afb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .afb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .afb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .afb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .afb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .afb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .afb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .afb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .afb-flexCol {
          flex: 1 1 260px;
        }

        .afb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .afb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .afb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .afb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #6366f1;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .afb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .afb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .afb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .afb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .afb-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .afb-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .afb-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .afb-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* BANNER */
        .afb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .afb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .afb-banner img {
            height: 270px;
          }
        }

        .afb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .afb-bannerText {
          color: #e0e7ff;
          font-size: 15px;
          max-width: 420px;
        }

        .afb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .afb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .afb-bannerButtons .primary {
          background: #6366f1;
          color: #eef2ff;
        }

        .afb-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .afb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .afb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .afb-bottomText strong {
          color: #c7d2fe;
        }

        .afb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .afb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .afb-bottomActions .primary {
          background: #6366f1;
          color: #eef2ff;
        }

        .afb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .afb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="afb-page">
        <div className="afb-inner">
          {/* HERO */}
          <section className="afb-hero">
            <div>
              <div className="afb-tag">
                <span className="afb-tagDot" />
                Ankle · Achilles · Foot
              </div>
              <h1 className="afb-title">
                Help your ankle and foot feel steady again, not tight or touchy with every step.
              </h1>
              <p className="afb-subtitle">
                The Achilles tendon, plantar fascia, and small foot muscles work together every time you walk,
                climb stairs, or stand. When they&apos;re irritated, even short walks or first steps in the morning
                can feel stiff or sharp.
              </p>

              <div className="afb-chips">
                <span className="afb-chip">Achilles tightness</span>
                <span className="afb-chip">Heel or arch pain</span>
                <span className="afb-chip">Sore toes or ball of foot</span>
                <span className="afb-chip">Post-ankle sprain stiffness</span>
              </div>

              <div className="afb-ctaRow">
                <button
                  className="afb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book an ankle & foot visit →
                </button>
                <button
                  className="afb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="afb-heroImgWrap">
              <img
                src="/content/ankle-foot-back/ankle_foot_back_hero.png"
                alt="Therapist assessing Achilles and back of ankle"
                className="afb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="afb-stripe">
            <div className="afb-sectionTitle">What can go wrong at the ankle, Achilles & foot?</div>
            <p className="afb-sectionSubtitle">
              The back of the ankle and the bottom of the foot help absorb shock and push you forward. With
              sudden overload, shoes that don&apos;t match your needs, or long days on your feet, these tissues
              can start to complain.
            </p>

            <div className="afb-flexRow">
              <div className="afb-flexCol">
                <ul className="afb-list">
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Achilles tightness or burning at the back of the heel, especially with walking or climbing stairs.
                    </span>
                  </li>
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Sharp or aching pain in the bottom of the foot or heel, especially with first steps in the morning.
                    </span>
                  </li>
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Fatigue in the arch or toes after standing or walking for longer periods.
                    </span>
                  </li>
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Stiffness or wobbliness after an ankle sprain or other ankle injury.
                    </span>
                  </li>
                </ul>

                <div className="afb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="afb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if this sounds like you →
                  </button>
                  <button
                    className="afb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="afb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/ankle-foot-back/ankle_achilles.png"
                  alt="Manual therapy on Achilles tendon"
                  className="afb-img"
                />
              </div>
            </div>

            <div className="afb-cardGrid">
              <div className="afb-card">
                <div className="afb-cardTitle">Achilles Tendon</div>
                <div className="afb-cardText">
                  Connects your calf muscles to your heel bone and helps you push off with each step or jump.
                </div>
              </div>
              <div className="afb-card">
                <div className="afb-cardTitle">Plantar Fascia</div>
                <div className="afb-cardText">
                  A strong band of tissue along the bottom of your foot that helps support the arch and absorb shock.
                </div>
              </div>
              <div className="afb-card">
                <div className="afb-cardTitle">Foot Arch & Intrinsics</div>
                <div className="afb-cardText">
                  Small muscles in your foot that help keep the arch supported and your toes working smoothly.
                </div>
              </div>
            </div>
          </section>

          {/* PLANTAR FASCIA / ARCH */}
          <section className="afb-stripe">
            <div className="afb-flexRow">
              <div className="afb-flexCol">
                <img
                  src="/content/ankle-foot-back/ankle_plantar_fascia.png"
                  alt="Therapist assessing plantar fascia and foot arch"
                  className="afb-img"
                />
              </div>

              <div className="afb-flexCol">
                <div className="afb-sectionTitle">That sharp “first step” foot or heel pain</div>
                <p className="afb-sectionSubtitle">
                  When the plantar fascia or arch muscles are irritated, they often complain during first steps
                  or after you&apos;ve been still for a while. PT looks beyond just stretching the bottom of the foot.
                </p>

                <ul className="afb-list">
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Pain with first steps in the morning that often eases as you keep moving.
                    </span>
                  </li>
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Tenderness along the heel or arch when pressed or after longer walks.
                    </span>
                  </li>
                  <li>
                    <span className="afb-bullet" />
                    <span>
                      Tension that seems to shift between heel, arch, and toes over the day.
                    </span>
                  </li>
                </ul>

                <div className="afb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="afb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start ankle & foot PT →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="afb-stripe">
            <div className="afb-sectionTitle">How physical therapy supports your ankle, Achilles & foot</div>
            <p className="afb-sectionSubtitle">
              We look at how your calf, ankle, arch, and even hips and knees contribute to what you feel in your
              heel, Achilles, or foot.
            </p>

            <div className="afb-twoColGrid">
              <div className="afb-pillBox">
                <div className="afb-pillTitle">Calm irritated tissue</div>
                <div className="afb-pillText">
                  Hands-on treatment, taping options, and comfortable positions to reduce sensitivity in the
                  Achilles or foot.
                </div>
              </div>
              <div className="afb-pillBox">
                <div className="afb-pillTitle">Targeted stretching (without overdoing it)</div>
                <div className="afb-pillText">
                  Gentle calf, ankle, and foot mobility that match your current tolerance—not just aggressive stretching.
                </div>
              </div>
              <div className="afb-pillBox">
                <div className="afb-pillTitle">Arch & calf strengthening</div>
                <div className="afb-pillText">
                  Exercises for the calf, arch muscles, and toes so your foot can share the load with the rest of your leg.
                </div>
              </div>
              <div className="afb-pillBox">
                <div className="afb-pillTitle">Footwear & activity tweaks</div>
                <div className="afb-pillText">
                  Ideas for shoes, inserts, and pacing your activity so tissues can calm down while you stay as active as possible.
                </div>
              </div>
            </div>

            <div className="afb-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="afb-btnPrimary"
                onClick={() => navigate("/appointments")}
              >
                Book an ankle & foot session →
              </button>
              <button
                className="afb-btnSecondary"
                onClick={() => navigate("/insurance")}
              >
                Check my insurance
              </button>
            </div>
          </section>

          {/* EXERCISES / VISIT FLOW */}
          <section className="afb-stripe">
            <div className="afb-flexRow">
              <div className="afb-flexCol">
                <img
                  src="/content/ankle-foot-back/ankle_arch_strength.png"
                  alt="Patient doing arch and ankle strengthening exercises"
                  className="afb-img"
                />
              </div>

              <div className="afb-flexCol">
                <div className="afb-sectionTitle">What an ankle, Achilles & foot visit may look like</div>

                <div className="afb-twoColGrid">
                  <div className="afb-pillBox">
                    <div className="afb-pillTitle">1. Your story</div>
                    <div className="afb-pillText">
                      We talk about where you feel symptoms, what shoes you use, and what activities matter most to you.
                    </div>
                  </div>
                  <div className="afb-pillBox">
                    <div className="afb-pillTitle">2. Motion & strength check</div>
                    <div className="afb-pillText">
                      Gentle tests of ankle range, calf and foot strength, and how you stand and walk.
                    </div>
                  </div>
                  <div className="afb-pillBox">
                    <div className="afb-pillTitle">3. Hands-on & guided movement</div>
                    <div className="afb-pillText">
                      You try specific treatment techniques and exercises to see what eases tension or pain.
                    </div>
                  </div>
                  <div className="afb-pillBox">
                    <div className="afb-pillTitle">4. Short home plan</div>
                    <div className="afb-pillText">
                      You leave with a simple, repeatable routine—not pages of exercises—to build momentum between visits.
                    </div>
                  </div>
                </div>

                <div className="afb-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="afb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book an evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="afb-stripe">
            <div className="afb-banner">
              <img
                src="/content/ankle-foot-back/ankle_foot_back_banner.png"
                alt="Bright PT clinic for ankle and foot care"
              />
              <div className="afb-bannerOverlay">
                <div className="afb-bannerText">
                  Ankle and foot sessions happen in a calm, one-on-one setting where we match your plan
                  to your comfort level, footwear, and daily activity.
                </div>
                <div className="afb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule an ankle & foot visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="afb-stripe">
            <div className="afb-bottomStrip">
              <div className="afb-bottomText">
                If you notice sudden severe ankle or foot pain after a fall, can&apos;t put weight on the leg,
                see significant swelling or deformity, have calf or foot pain with warmth, redness, or unexplained
                shortness of breath, or numbness spreading into the foot,{" "}
                <strong>seek urgent or emergency medical care first.</strong> Physical therapy can then help
                you safely rebuild strength and confidence once serious causes are ruled out.
              </div>
              <div className="afb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule ankle & foot PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default AnkleFootBackPT;
